import { PipesModule } from './pipes/pipes.module';
import { ComponentsModule } from 'src/app/modules/components/components.module';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { UserService } from './services/user.service';
import { HttpClientModule } from '@angular/common/http';
import { StoreService } from './services/store.service';
import { IonicStorageModule, Storage } from '@ionic/storage';
import { NavService } from './services/nav.service';
import { CommonService } from './services/common.service';
import { Ui } from './services/ui.service';
import { DatePipe } from '@angular/common';

export function createStore(storage: Storage) {
  return new StoreService(storage);
}
@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot({
      mode: 'ios'
    }),
    AppRoutingModule,
    ComponentsModule,
    HttpClientModule,
    PipesModule,
    IonicStorageModule.forRoot()
  ],
  providers: [
    StatusBar,
    UserService,
    CommonService,
    Ui,
    SplashScreen,
    DatePipe,
    NavService,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {provide: StoreService, deps: [Storage],  useFactory: createStore},
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
